'use client';

import styled from '@emotion/styled';

const StyledOnlyShowDifferencesSwitch = styled.section`
  label {
    position: sticky;
    left: 0;
  }

  &.checked + div {
    .all-values-are-same,
    /*
      details:not(
        :has(
          .property-row:not(.all-values-are-same)
        )
      )
    */
    details:not(:has(.property-row:not(.all-values-are-same))) {
      display: none;
    }
  }

  ${({ theme }) => theme.breakpoint.maxWidth('lg')} {
    margin-top: ${({ theme }) => theme.spacing[400]};
  }
`;

export { StyledOnlyShowDifferencesSwitch };
